import CircleExclamationSolid from '@gef-ui/material-icons/CircleExclamationSolid';
import PropTypes from 'prop-types';
import React from 'react';
import FieldTooltip from '../FieldTooltip';
import { useDefaultComponentValue } from '../utils';
const COMPONENT_NAME = 'ValidationTooltip';
const ValidationTooltip = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { errorMessage, validationColor, placement = 'field-left', ...other } = props;
    return /*#__PURE__*/ React.createElement(FieldTooltip, {
        message: errorMessage,
        color: validationColor,
        Icon: CircleExclamationSolid,
        placement: placement,
        ...other
    });
};
ValidationTooltip.propTypes = {
    errorMessage: PropTypes.string,
    placement: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    validationColor: PropTypes.string
};
export default ValidationTooltip;
